<div fxLayout="row" fxLayoutGap="15px">
  <div fxFlex='70%'>
    <h1 mat-dialog-title>
        Add Design Professional
    </h1>
  </div>
  <div fxFlex='30%'>
    <a href="javascript:void(0)" (click)="onClickClose()" style="color: #8f8f8f">
      <mat-icon style="size: 18px; float: right !important;">close</mat-icon>
    </a>
  </div>
</div>

<div ngStyle.gt-sm="{'width':'800px'}" ngStyle.lt-md="{'width':'98%'}" style="min-height: 70%;">
  <mat-vertical-stepper [linear]="disableLinear" #stepper>
    <mat-step [stepControl]="formLicense">
      <form [formGroup]="formLicense">
        <ng-template matStepLabel>
          Lookup your  design professional {{ldpLicenseSummary}}
        </ng-template>

        <p>
          You must have a valid license number for the design professional.
        </p>
        <div>
        
            <mat-form-field appearance="outline">
              <mat-label>License Type</mat-label>
              <mat-select required id="licensetype" name="licensetype" formControlName="licensetype" required="true">
                <mat-option *ngFor="let item of licenseTypeOptions" [value]="item.value">{{ item.label }}</mat-option>
              </mat-select>
              <mat-error *ngIf="formLicense.get('licensetype').hasError('required')">
                License Type is required.
              </mat-error>
            </mat-form-field>
          
        </div>
        <div>
          <mat-form-field
            appearance="outline"
            style="width: 200px;">
            <mat-label>License Number</mat-label>
            <input matInput autocomplete="off"
              maxlength=100
              placeholder="License Number"
              id="licensenumber"
              name="licensenumber"
              formControlName="licensenumber"
              trim="blur">
              <mat-error
                *ngIf="onCheckFormLicenseControlValidators('licensenumber')">
                License required
              </mat-error>

             
          </mat-form-field>
        </div>
        <div *ngIf="invalidLicense" class="warn-text" style="width: 100%; max-width: 500px;word-wrap: break-word; white-space: normal;">
          {{invalidLicenseClassificationMsg}}
        </div>
 <!-- <div  *ngIf="invalidLicense" ><span class="warn-text">{{invalidLicenseClassificationMsg}}</span></div> -->
        <div>
          <div>
            <button mat-stroked-button color="primary"
              (click)="onLookupLicenseNumber()">
              LOOKUP DESIGN PROFESSIONAL
            </button>
          </div>
        </div>
        <div *ngIf="isldpexists">

          <div fxLayout="row" fxLayout.lt-md="column wrap" *ngIf="isExistldpData">
               <div fxFlex='50%'>
              <div style="margin-top: 12px;" [ngStyle.lt-md]="{'margin-left': '9px'}">
                <div
                    matTooltip="{{isExistldpData.businessName}}"
                    class="business-name"
                  >
                    {{ isExistldpData.businessName }}
                  </div>
                  <div style="font-size: 12px;">
                    {{ isExistldpData.address2_Line1 }}, {{ isExistldpData.address2_Line2 ? isExistldpData.address2_Line2 + ',' : '' }} {{ isExistldpData.address2_City }}, {{ isExistldpData.address2_StateOrProvince }}
                    {{ isExistldpData.address2_PostalCode }}
                  </div>
                  <div style="font-size: 12px;">
                    (License #:
                    <span
                      *ngIf="
                        isExistldpData.ldpLicenseNumber &&
                        isExistldpData.ldpLicenseNumber.length > 0;
                        else: licenseNoUnavailable
                      "
                    >
                      {{ isExistldpData.ldpLicenseNumber }})
                    </span>
                    <ng-template #licenseNoUnavailable>
                      <span>Unavailable)</span>
                    </ng-template>
                  </div>
               
              </div>
            </div>
            <div fxFlex='50%'>
              <div style="margin-top: 12px;" [ngStyle.lt-md]="{'margin-left': '9px'}">
                <div style="font-size: 12px;">
                  Email: {{isExistldpData.emailAddress1}}
                </div>
                <div style="font-size: 12px;">
                  Phone:
                    <span
                      *ngIf="isExistldpData.address2_Telephone1 && isExistldpData.address2_Telephone1.length > 0 else phoneUnavailable">
                      {{isExistldpData.address2_Telephone1}}
                    </span>
                    <ng-template #phoneUnavailable>
                      <span>Unavailable</span>
                    </ng-template>
                </div>
                <div style="font-size: 12px;">
                  Web:
                  <span *ngIf="isExistldpData.webSiteUrl && isExistldpData.webSiteUrl.length > 0;  else: websiteUnavailable">
                    <a target="_blank" rel="noopener" href="{{formatLink(isExistldpData.webSiteUrl)}}">
                      {{formatLink(isExistldpData.webSiteUrl)}}</a>
                  </span>
                  <ng-template #websiteUnavailable>
                    <span>Unavailable</span>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
      
          <P><b>Your design professional already exists in our system</b></P>

          <button mat-stroked-button color="primary"
          (click)="onExistingLdpSelect()">
          SELECT DESIGN PROFESSIONAL
        </button>
        </div>
        <div *ngIf="invalidLicenseClassification" style="margin-top: 12px;" [ngStyle.lt-md]="{'margin-left': '9px'}">
          <p>{{invalidLicenseClassificationMsg}}Message</p>
        </div>

        <div *ngIf="ldpData  && !isldpexists"
          style="margin: 12px 0 12px 9px; ">
          <span *ngIf="ldpData.firstName && ldpData.firstName.length > 0">
            {{ldpData.firstName}}  {{ldpData.lastName}}
          </span>
          <div>
            <span *ngIf="ldpData.address1 && ldpData.address1.length > 0">
              {{ldpData.address1}} 
            </span>
            <span *ngIf="ldpData.address1 && ldpData.address1.length > 0">
              {{ldpData.city}}, {{ldpData.state}} {{ldpData.zipCode}}
            </span>
            
            <div>
              <span *ngIf="ldpData.expirationDate && ldpData.expirationDate.length > 0">
                License expiration: {{displayLicenseExpiration()}}
              </span>
            </div>
          </div>
        </div>

       

        <div *ngIf="checkLicense" style="margin-top: 12px; margin-bottom: 12px;">
          <mat-progress-bar mode="indeterminate" style="width: 300px;"></mat-progress-bar>
        </div>

        <div style="margin-top: 21px;">
          <button mat-stroked-button matStepperNext color="primary"
            [disabled]="this.disableNext1" >
            CONTINUE
          </button>
        </div>

      </form>
    </mat-step>
    <mat-step [stepControl]="formContact"  *ngIf="licensecheckdone" >
      <form [formGroup]="formContact" >
        <ng-template matStepLabel>Provide design professional details {{ldpContactInfoSummary}}</ng-template>
        <!-- <div>
          <mat-form-field
            appearance="outline"
            style="width: 200px;">
            <mat-label>Business name</mat-label>
            <input matInput autocomplete="off"
              maxlength=100
              placeholder="Business name"
              id="businessName"
              name="businessName"
              formControlName="businessName"
              trim="blur" required>
            <mat-error
              *ngIf="onCheckFormContactControlValidators('businessName')">
              Business name required
            </mat-error>
            <mat-hint *ngIf="onCheckFormContactControlLengthHint('businessName', 100)">
              100 character limit
            </mat-hint>
          </mat-form-field>

        </div> -->
        <div>
          <mat-form-field
            appearance="outline"
            style="width: 200px;">
            <mat-label>First Name</mat-label>
            <input matInput autocomplete="off"
              maxlength=100
              placeholder="First name"
              id="firstName"
              name="firstName"
              formControlName="firstName"
              trim="blur" required>
            <mat-error
              *ngIf="onCheckFormContactControlValidators('firstName')">
              First name required
            </mat-error>
            <mat-hint *ngIf="onCheckFormContactControlLengthHint('firstName', 100)">
              100 character limit
            </mat-hint>
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            style="width: 200px;">
            <mat-label>Last Name</mat-label>
            <input matInput autocomplete="off"
              maxlength=100
              placeholder="Last name"
              id="lastName"
              name="lastName"
              formControlName="lastName"
              trim="blur" required>
            <mat-error
              *ngIf="onCheckFormContactControlValidators('lastName')">
              Last name required
            </mat-error>
            <mat-hint *ngIf="onCheckFormContactControlLengthHint('lastName', 100)">
              100 character limit
            </mat-hint>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field
            appearance="outline"
            style="width: 150px;">
            <mat-label>Phone</mat-label>
            <input matInput autocomplete="off"
              placeholder="Phone"
              mask="(000) 000-0000"
              id="telephone1"
              name="telephone1"
              formControlName="telephone1"
              trim="blur" required >
            <mat-error
              *ngIf="onCheckFormContactControlValidators('telephone1')">
              Phone required
            </mat-error>
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            style="width: 250px;">
            <mat-label>Email</mat-label>
            <input matInput autocomplete="off"
              type="email"
              placeholder="Email address"
              id="emailAddress2"
              name="emailAddress2"
              formControlName="emailAddress2"
              trim="blur" required  (ngModelChange)="onEmailChange()">
            <mat-error
              *ngIf="onCheckFormContactControlValidators('emailAddress2')">
              Valid email required
            </mat-error>
          </mat-form-field>
        </div>

      <!-- Error Message for Existing Email -->
   
    <div *ngIf="isEmailExists" class="warn-text" style="width: 100%; max-width: 500px;word-wrap: break-word; white-space: normal;">
      <p>{{invalidContactClassificationMsg}}</p>
    </div>
        <div style="margin-top: 21px;">
          <button mat-button matStepperPrevious>
            BACK
          </button>
          <button mat-stroked-button matStepperNext color="primary"
            (click)="setLdpContactInfoSummary()"
            [disabled]="formContact.invalid || isEmailExists|| isEmailCheckInProgress" 
            >
            CONTINUE
          </button>
        </div>

      </form>
    </mat-step>
    <mat-step *ngIf="licensecheckdone" >
      <form [formGroup]="formMailing">
        <ng-template matStepLabel>Design Professional mailing address {{contractMailingAddressSummary}}</ng-template>

        <div>
          <mat-checkbox style="margin-left: 3px; font-size: 14px;"
          id="sameAsBusinessAddress"
          name="sameAsBusinessAddress"
          formControlName="sameAsBusinessAddress"
          (change)="onCheckSameAsBusinessAddress($event)">
            Mailing address is same as business address.
        </mat-checkbox>
        </div>
        <div style="margin-top: 6px;">
          <div>
            <mat-form-field
              appearance="outline"
              style="width: 300px; max-width:100%;">
              <mat-label>Street Address</mat-label>
              <input matInput autocomplete="off"
                maxlength=250
                placeholder="Street Address"
                id="address3_Line1"
                name="address3_Line1"
                formControlName="address3_Line1"
                trim="blur" required>
                <mat-error
                  *ngIf="onCheckFormMailingControlValidators('address3_Line1')">
                  Street address required
                </mat-error>
                <mat-hint *ngIf="onCheckFormMailingControlLengthHint('address3_Line1', 250)">
                  250 character limit
                </mat-hint>
            </mat-form-field>
          </div><div>
            <mat-form-field
            appearance="outline"
            style="width: 300px; max-width:100%;">
            <mat-label>Street Address Line 2</mat-label>
            <input matInput autocomplete="off"
              maxlength=250
              placeholder="Street Address Line 2"
              id="address3_Line2"
              name="address3_Line2"
              formControlName="address3_Line2"
              trim="blur">
              <mat-hint *ngIf="onCheckFormMailingControlLengthHint('address3_Line2', 250)">
                250 character limit
              </mat-hint>
          </mat-form-field>
          </div><div>
            <mat-form-field
              appearance="outline"
              style="width: 125px;">
              <mat-label>City</mat-label>
                <input matInput autocomplete="off"
                  maxlength=80
                  placeholder="City"
                  id="address3_City"
                  name="address3_City"
                  formControlName="address3_City"
                  trim="blur" required>
                <mat-error
                  *ngIf="onCheckFormMailingControlValidators('address3_City')">
                  City required
                </mat-error>
                <mat-hint *ngIf="onCheckFormMailingControlLengthHint('address3_City', 80)">
                  80 character limit
                </mat-hint>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              style="width: 75px;">
              <mat-label>State</mat-label>
              <input matInput autocomplete="off"
                maxlength=50
                placeholder="State"
                id="address3_StateOrProvince"
                name="address3_StateOrProvince"
                formControlName="address3_StateOrProvince"
                trim="blur" required>
              <mat-error
                *ngIf="onCheckFormMailingControlValidators('address3_StateOrProvince')">
                State required
              </mat-error>
              <mat-hint *ngIf="onCheckFormMailingControlLengthHint('address3_StateOrProvince', 50)">
                50 character limit
              </mat-hint>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              style="width: 75px;">
              <mat-label>ZIP</mat-label>
              <input matInput autocomplete="off"
                maxlength=20
                placeholder="ZIP Code"
                id="address3_PostalCode"
                name="address3_PostalCode"
                formControlName="address3_PostalCode"
                trim="blur" required>
                <mat-error
                  *ngIf="onCheckFormMailingControlValidators('address3_PostalCode')">
                  ZIP Code required
              </mat-error>
              <mat-hint *ngIf="onCheckFormMailingControlLengthHint('address3_PostalCode', 20)">
                20 character limit
              </mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div style="margin-top: 21px;">
          <button mat-button matStepperPrevious>BACK</button>
          <button mat-flat-button color="primary"
            [disabled]="disableSave ||
                        (formContact.pristine || formContact.invalid) ||
                        (formMailing.pristine || formMailing.invalid)"
            (click)="onSave()">
            SAVE
          </button>
        </div>
      </form>
    </mat-step>
  </mat-vertical-stepper>
</div>
